import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import colors from './Theme/colors';

export const SpinnerContainer = styled.div<{
  fullScreen?: boolean;
  height?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: stretch;
  overflow: hidden;
  ${({ fullScreen }) => fullScreen && `
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2;
  `}
  ${({ height }) => height && `
    height: ${height};
  `}
`;

const StyledSpinner = styled.svg`
  margin: auto;
  animation: rotate 2s linear infinite;
  width: 50px;
  height: 50px;
  padding: 40px;

  & .path {
    stroke: url(#spinner-gradient);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

const spinnerPropertyTypes = {
  stroke: PropTypes.string,
};

type SpinnerProperties = InferProps<typeof spinnerPropertyTypes>;

const Spinner = ({ stroke }: SpinnerProperties) => (
  <StyledSpinner
    className="loader"
    viewBox="0 0 50 50"
  >
    <defs>
      <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop
          offset="0%"
          stopColor={stroke ?? colors.primary}
          stopOpacity="0.2"
        />
        <stop
          offset="50%"
          stopColor={stroke ?? colors.primary}
          stopOpacity="0.8"
        />
        <stop
          offset="100%"
          stopColor={stroke ?? colors.primary}
          stopOpacity="1"
        />
      </linearGradient>
    </defs>
    <circle
      className="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      strokeWidth="4"
    />
  </StyledSpinner>
);

Spinner.propTypes = {
  stroke: PropTypes.string,
};

export default Spinner;
